<script>
import Base from '@/plans/VIDEO_SDK/config/base';

export default {
  extends: Base,
  computed: {
    canRmv() {
      return false;
    },
  },
};
</script>
